import { PageTrail } from '../../shared/sso-workspace/page-trail'
import { SECTION } from '../../shared/navigation/sections'

// The LMS pages' trail in the admin's top bar, the same one every other section
// uses (context/breadcrumb.context.js): LMS > Courses > <course> > Build log.
// Every page names its whole trail, as { url, text }, because the LMS routes
// are siblings (layout-lms.js), not nested, so no ancestor route mounts the
// earlier crumbs. The section's own crumb is /org/lms (which goes to
// Connections). A crumb whose name is still loading is passed as '' and is left
// out until the name arrives. (The trail itself is shared: page-trail.js.)
// The sidebar's Integrations > LMS: its name and icon (shared/navigation/sections.js).
export const LMS_CRUMB = SECTION.lms

export const lmsTrail = (...crumbs) => [LMS_CRUMB, ...crumbs]

export const LmsTrail = PageTrail
